require('./bootstrap');

require("./functions/select-tag");
require("./functions/burger-menu");
require("./functions/sticky-header-shadow");